module.exports = __webpack_public_path__ + "static/media/apartment4.eae1c75d.jpg";